import { Timestamp } from "firebase/firestore";

// Define user roles
export const USER_ROLES = {
  USER: "user", // Regular users who can only see their assigned classes
  MANAGER: "manager", // Managers with full administrative access
};

class UserModel {
  constructor(data = {}) {
    this.id = data.id || null;
    this.email = data.email || "";
    this.displayName = data.displayName || "";
    this.role = data.role || USER_ROLES.USER; // Default role is user
    this.createdAt = data.createdAt || Timestamp.now();
    this.updatedAt = data.updatedAt || Timestamp.now();
    this.phoneNumber = data.phoneNumber || ""; // Added phone number
    this.linkedStaffId = data.linkedStaffId || null; // ID of linked staff record
    this.enrolledClasses = data.enrolledClasses || []; // For students
  }

  // Create a Firestore document from this model
  toFirestore() {
    // Don't include the id field in the Firestore document
    const { id, ...docData } = this;
    return {
      ...docData,
      updatedAt: Timestamp.now(), // Always update the timestamp
    };
  }

  // Create a model from Firestore document
  static fromFirestore(doc) {
    if (!doc) return null;
    return new UserModel({
      id: doc.id,
      ...doc.data(),
    });
  }

  // Check role methods
  isManager() {
    return this.role === USER_ROLES.MANAGER;
  }

  isUser() {
    return this.role === USER_ROLES.USER;
  }

  // Role change methods
  promoteToManager() {
    this.role = USER_ROLES.MANAGER;
    this.updatedAt = Timestamp.now();
    return this;
  }

  demoteToUser() {
    this.role = USER_ROLES.USER;
    this.updatedAt = Timestamp.now();
    return this;
  }

  // Check if user is linked to a staff record
  isLinkedToStaff() {
    return !!this.linkedStaffId;
  }

  // Debug method to log user details
  logUserDetails() {
    console.log(`UserModel - User Details:
    ID: ${this.id}
    Email: ${this.email}
    Display Name: ${this.displayName}
    Role: ${this.role}
    Phone: ${this.phoneNumber}
    Linked Staff ID: ${this.linkedStaffId || "none"}
    Enrolled Classes: ${this.enrolledClasses?.length || 0}
    Created: ${this.createdAt?.toDate?.() || "unknown"}
    Updated: ${this.updatedAt?.toDate?.() || "unknown"}`);
    return this;
  }
}

export default UserModel;
